const sortedCountriesList = (locale) => {
  const countriesList = Object.entries(require(`../components/locales/countries/${locale}`).default)
  const mostUsedCountries = countriesList.splice(0, 3)
  const sortedList = countriesList
    .sort((a, b) => { return a[1].localeCompare(b[1]) })

  return mostUsedCountries.concat(sortedList)
}

export default sortedCountriesList



// WEBPACK FOOTER //
// ./app/javascript/helpers/sorted_countries_list.js